module.exports = __webpack_public_path__ + "img/notConfigured.f13826f3.svg";